// extracted by css-extract-rspack-plugin
export default {"container":"container-CBY8SY","title":"title-Ys9DWm","rows":"rows-R9wMqu","row":"row-YCVzvg"};